import { createAsyncThunk } from '@reduxjs/toolkit';

import { UpdateAlertProps } from 'entities/Alert';

import {
  getAlertListService,
  updateAlertService,
} from 'services/alert.service';

export const getAlertList = createAsyncThunk(
  'alert/list',
  async (_, thunkApi) => {
    try {
      const response = await getAlertListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const updateAlert = createAsyncThunk(
  'alert/update',
  async (data: UpdateAlertProps, thunkApi) => {
    try {
      const response = await updateAlertService(data);

      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
